import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, renderSlot as _renderSlot, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "ml-auto" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_range_slider = _resolveComponent("v-range-slider")!
  const _component_v_slider = _resolveComponent("v-slider")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["slider", {disabled:_ctx.disabled, hideThumb:_ctx.hideThumb}])
  }, [
    (_ctx.displayValuesInline)
      ? (_openBlock(), _createBlock(_component_v_row, {
          key: 0,
          class: "ma-0 mb-n2 token-text-medium"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              (_ctx.range && _ctx.insideValues)
                ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.insideValues[0]) + " - " + _toDisplayString(_ctx.insideValues[1]) + " " + _toDisplayString(_ctx.valuesInlineAppend), 1))
                : (!_ctx.range && _ctx.insideValue)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.insideValue) + " " + _toDisplayString(_ctx.valuesInlineAppend), 1))
                  : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_v_row, {
      class: _normalizeClass(_ctx.displayValuesInline ? 'ma-0': 'ma-2')
    }, {
      default: _withCtx(() => [
        (_ctx.range)
          ? (_openBlock(), _createBlock(_component_v_range_slider, {
              key: 0,
              modelValue: _ctx.insideValues,
              "onUpdate:modelValue": [
                _cache[0] || (_cache[0] = ($event: any) => ((_ctx.insideValues) = $event)),
                _ctx.updateValues
              ],
              "hide-details": true,
              step: _ctx.step || 1,
              min: _ctx.min,
              max: _ctx.max,
              "show-ticks": _ctx.hideTicks ? false : 'always',
              "thumb-label": _ctx.hideThumbLabels ? false : 'always',
              disabled: _ctx.disabled,
              "tick-size": "4",
              "track-fill-color": "rgba(50, 25, 178, 1)",
              "track-color": "rgba(0, 0, 58, 0.3)"
            }, {
              "thumb-label": _withCtx(({ modelValue }) => [
                _renderSlot(_ctx.$slots, "thumb-label", { modelValue: modelValue }, () => [
                  _createTextVNode(_toDisplayString(modelValue), 1)
                ], true)
              ]),
              _: 3
            }, 8, ["modelValue", "step", "min", "max", "show-ticks", "thumb-label", "disabled", "onUpdate:modelValue"]))
          : (_openBlock(), _createBlock(_component_v_slider, {
              key: 1,
              modelValue: _ctx.insideValue,
              "onUpdate:modelValue": [
                _cache[1] || (_cache[1] = ($event: any) => ((_ctx.insideValue) = $event)),
                _ctx.updateValue
              ],
              "hide-details": true,
              step: _ctx.step || 1,
              min: _ctx.min,
              max: _ctx.max,
              "show-ticks": 'always',
              "thumb-label": _ctx.hideThumbLabels ? false : 'always',
              disabled: _ctx.disabled,
              "tick-size": "4",
              "track-fill-color": "rgba(50, 25, 178, 1)",
              "track-color": "rgba(0, 0, 58, 0.3)",
              onEnd: _ctx.end
            }, {
              "thumb-label": _withCtx(({ modelValue }) => [
                _renderSlot(_ctx.$slots, "thumb-label", { modelValue: modelValue }, () => [
                  _createTextVNode(_toDisplayString(modelValue), 1)
                ], true)
              ]),
              _: 3
            }, 8, ["modelValue", "step", "min", "max", "thumb-label", "disabled", "onUpdate:modelValue", "onEnd"]))
      ]),
      _: 3
    }, 8, ["class"])
  ], 2))
}